// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".spin[data-v-17be9245]{border-radius:50%;border:4px solid rgba(0,0,0,.467);border-top-color:#09408c;display:block;margin:0 auto}.title-modal[data-v-17be9245]{font-weight:700}.close-button[data-v-17be9245]{color:red;font-weight:600}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
